/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/power-of-attorney.css';
import { Button, Segment, Form, Input, Header, Icon, List, Dropdown, Modal, Progress} from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import moment from 'moment';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class PowerOfAttorney extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      progress: 77.7,
      BII: '',
      DBA: '',
      streetAddress: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
      ports: [],
      port: '',
      eSignature: [],
      eSign: '',
      title: '',
      date: moment().format('MMMM Do YYYY'),
      show: false
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value },
    console.log('TEST', this.state)
  )

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

  handleSubmit = () => {
    const { DBA, city, state, zipcode, streetAddress, country, port, eSign, date, title, ports } = this.state

    if (this.state.port.length > 0) {
      this.setState({ ports: [...ports, port], port: '' })
    }
    this.setState({ city, state, zipcode, streetAddress, country, eSign, date, title })

    API.poa(

    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("poa", "item progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("poa", "piece progress-gray")
  }

  removePort = (item) => this.setState({ ports: this.state.ports.filter(elem => elem !== item) })

  render() {
    const { DBA, city, state, zipcode, streetAddress, country, port, eSign, date, title } = this.state
    const optionsBII = [
      { key: 'DE', text: 'DE - Delaware, US', value: 'DE' },
      { key: 'N', text: 'Next', value: 'N' },
    ]
    // const optionsDBA = [
    //   { key: 'DE', text: 'DE - Delaware, US', value: 'DE' },
    //   { key: 'O', text: 'Other', value: 'O' },
    // ]
    const optionsState = [
      { key: 'CA', text: 'CA', value: 'CA' },
      { key: 'NV', text: 'NV', value: 'NV' },
    ]
    const optionsCountry = [
      { key: 'USA', text: 'United States', value: 'USA' },
      { key: 'KH', text: 'Canada', value: 'KH' },
    ]

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("poa", "piece progress-green")
			return <Redirect to='/payment' />
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <h2 className="ai2h2">Account Information</h2>
        <Segment padded='very' className="poa1-segment-container" raised>
          <Form onSubmit={this.handleSubmit.bind(this)}>
            <Header as='h1'>Power of Attorney</Header>
            <Form.Field>
              <label className="power-of-attorney-label">BUSINESS INCORPORATED IN</label>
              <Dropdown fluid selection scrolling className='poa1-dropdown' options={optionsBII} search placeholder={optionsBII[0].text}
              />
              <label className="power-of-attorney-label">DBA (DOING BUSINESS AS)</label>
              <Input name="DBA" fluid placeholder='Enter Business here' value={DBA} onChange={this.handleChange.bind(this)} className="power-of-attorney-input" />
            </Form.Field>
            <Form.Field>
              <label className="power-of-attorney-label">BUSINESS ADDRESS</label>
              <Input
                name="streetAddress"
                value={streetAddress}
                className="power-of-attorney-input"
                placeholder='Enter Address here'
                onChange={this.handleChange.bind(this)}
              />
              <Form.Group className="poa1-form-group">
                <Form.Input onChange={this.handleChange.bind(this)} name="city" value={city} placeholder='City' width={8} />
                <Form.Dropdown onChange={this.handleChange.bind(this)} name="state" value={state} className="poa1-state-dropdown" placeholder='State' options={optionsState} width={5} />
                <Form.Input onChange={this.handleChange.bind(this)} name="zipcode" value={zipcode} placeholder='Zipcode' width={6} />
              </Form.Group>
              <Dropdown fluid selection scrolling className='poa1-dropdown' options={optionsCountry} search placeholder={optionsCountry[0].text}
              />
            </Form.Field>
            <Form.Field>
              <label className="power-of-attorney-label">PORTS</label>
              <Input name="port" value={port} className="power-of-attorney-input" placeholder='Enter Port Address here' onChange={this.handleChange.bind(this)}
              />
              <br />
              <br />
              <Icon name="add" color="blue" onClick={this.handleSubmit.bind(this)} />
              <Link to='#' className="addFFCB" onClick={this.handleSubmit.bind(this)}> Add More</Link>
              <List>
                {this.state.ports.map((a, i) => {
                  return <List.Item key={i} as="h5"><Icon name="remove" onClick={() => this.removePort(a)} /> Port: {a}</List.Item>
                })}
              </List>
            </Form.Field>
            <Form.Field>
              <Modal trigger={<Button inverted fluid color='blue'> VIEW & SIGN POWER OF ATTORNEY DOCUMENT </Button>} basic centered={false}>
                <Modal.Content>
                  <iframe id='docusign' src="https://demo.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b034d5ca-8eed-4f31-8694-9f82707608f3&env=demo&v=2"/>
                </Modal.Content>
              </Modal>
            </Form.Field>
            
            <div className="poa-buttonRow">
              <Link to='/accountInfo4'>
                <Button type='submit' className="power-of-attorney-cancel">CANCEL</Button>
              </Link>
              <Link to='/payment'>
                <Button type='submit' className="power-of-attorney-skip" onClick={this.handleSkip}>SKIP THIS</Button>
              </Link>
              {/* <Link to='/payment'> */}
                <Button type='submit' className="power-of-attorney-save" onClick={this.handleSubmit} color="twitter">SAVE & NEXT</Button>
              {/* </Link> */}
            </div>
          </Form>
        </Segment>
      </div>
      // </div>
    );
  }
}

export default PowerOfAttorney;
